import {useEffect,useState} from 'react';
import {AbsoluteFill,continueRender,delayRender,staticFile} from 'remotion';
import {Audio} from '@remotion/media';
import {DirectorCut} from './DirectorCut';

// Same permanent ProMaxVertical Remotion composition: new creative direction, no new project.
const Fonts=()=>{
  const [handle]=useState(()=>delayRender('Loading local Tajawal fonts'));
  useEffect(()=>{
    Promise.all([
      new FontFace('Tajawal', 'url('+staticFile('fonts/Tajawal-Regular.ttf')+')',{weight:'400'}).load(),
      new FontFace('Tajawal', 'url('+staticFile('fonts/Tajawal-Bold.ttf')+')',{weight:'700'}).load(),
    ]).then((fonts)=>{
      fonts.forEach(font=>document.fonts.add(font));
      continueRender(handle);
    }).catch((error)=>{
      console.error(error);
      continueRender(handle);
    });
  },[handle]);
  return null;
};

export const ProMax=()=> <AbsoluteFill>
  <Fonts/>
  <DirectorCut/>
  <Audio name="الإيقاع والمؤثرات — ProMax" src={staticFile('audio/soundtrack.wav')}/>
</AbsoluteFill>;
